import type { Establishment } from './models';
import { RestService, Rest } from '@abp/ng.core';
import { Injectable, inject } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class EstablishmentsService {
  private restService = inject(RestService);
  apiName = 'Default';
  

  getEstablishments = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, Establishment[]>({
      method: 'GET',
      url: '/api/app/establishments/establishments',
    },
    { apiName: this.apiName,...config });
}